export default __webpack_public_path__ + "static/media/metabolic@3x.e8ef68c4.jpg";